import { Base } from '@gate31/core/src/libs/BaseComponent';
import LiquidRender from '@gate31/uikit/common/scripts/liquid-render';
import { ReviewsApi } from '@gate31/core/src/api/MneniyaApi';
import Client from '@gate31/uikit/common/components/client/client';
import { ClientResponseInt } from '@gate31/types/client';
import { InsalesProduct } from '@gate31/feature/InsalesProduct/InsalesProduct';
import InputImages from '@gate31/uikit/common/components/input-images/input-images';
import { DEFAULT_TEXT } from '@gate31/feature/reviews/reviews';

interface ProductReviewsFormOptions {
    product: InsalesProduct;
}

export class ProductReviewsFormDesk extends Base<HTMLFormElement> {
    static cn = new Base.BuildCn('ProductReviewsFormDesk');

    api = new ReviewsApi();
    client: ClientResponseInt | undefined;
    product: InsalesProduct;

    form: HTMLFormElement;
    submitButton: HTMLButtonElement;
    ratingInputs: NodeListOf<HTMLInputElement>;
    inputImages: InputImages;
    textareaComment: HTMLTextAreaElement | null;
    reviewsImageInputWrap: HTMLDivElement | null;
    reviewsContentWrap: HTMLDivElement | null;
    reviewsResultWrap: HTMLDivElement | null;

    constructor(node: HTMLFormElement, options: ProductReviewsFormOptions) {
        super(node);

        this.form = this.getRoot().querySelector(ProductReviewsFormDesk.cn.setElem('form').toSelector()) as HTMLFormElement;
        this.submitButton = this.getRoot().querySelector(ProductReviewsFormDesk.cn.setElem('btn').toSelector()) as HTMLButtonElement;
        this.ratingInputs = this.getRoot().querySelectorAll('[name=rating]');
        this.inputImages = new InputImages({ name: 'product-reviews' });
        this.textareaComment = this.getRoot().querySelector(ProductReviewsFormDesk.cn.setElem('coment-field').toSelector());
        this.reviewsImageInputWrap = this.getRoot().querySelector(ProductReviewsFormDesk.cn.setElem('files-input').toSelector());
        this.reviewsContentWrap = this.getRoot().querySelector(ProductReviewsFormDesk.cn.setElem('content').toSelector());
        this.reviewsResultWrap = this.getRoot().querySelector(ProductReviewsFormDesk.cn.setElem('result-wrap').toSelector());

        this.product = options.product;

        this.connectionCallback();
    }

    connectionCallback() {
        Client.get()
            .then(res => {
                this.client = res.status === 'ok' ? res : undefined;
            })
            .catch(() => {
                this.client = undefined;
            });

        this.submitButton.disabled = true;

        this.ratingInputs.forEach(rating => {
            rating.addEventListener('change', () => {
                this.submitButton.disabled = false;
                if (this.reviewsResultWrap) this.reviewsResultWrap.textContent = '';
            });
        });

        this.renderImageInput();

        this.form.addEventListener('submit', e => {
            e.preventDefault();

            this.handleForm();
        });
    }

    handleForm() {
        const formIsCorrect = this.checkForm();

        if (! formIsCorrect) {
            // Если форма не прошла проверку
            // todo Нужно ли? Кнопка замьюена до того как установлен рейтинг
            return;
        }

        this.sendForm();
    }

    renderImageInput(): void {
        if (! this.reviewsImageInputWrap) return;

        this.reviewsImageInputWrap.append(this.inputImages.template);
    }

    checkRating(): boolean {
        if (this.ratingInputs) {
            for (let i = 0; i < this.ratingInputs.length; i++) {
                if (this.ratingInputs[i].checked) return true;
            }
        }

        return false;
    }

    checkForm(): boolean {
        return this.checkRating();
    }

    renderResult(opts: { title: string; message: string; isError: boolean }, time: number) {
        if (! this.reviewsContentWrap || ! this.reviewsResultWrap) {
            return;
        }

        const templateMessage = LiquidRender.render('reviews-result-template', {
            title: opts.title,
            message: opts.message,
            error: opts.isError,
            className: ProductReviewsFormDesk.cn.toString()
        });
        const classHidden = ProductReviewsFormDesk.cn.setElem('content').setMode({ hidden: true }).toString();
        const classActive = ProductReviewsFormDesk.cn.setElem('result-wrap').setMode({ active: true }).toString();

        this.reviewsContentWrap.classList.add(classHidden);
        this.reviewsResultWrap.classList.add(classActive);

        this.reviewsResultWrap.innerHTML = templateMessage;

        if (time <= 0) {
            return;
        }

        setTimeout(() => {
            (this.reviewsContentWrap as HTMLDivElement).classList.remove(classHidden);
            (this.reviewsResultWrap as HTMLDivElement).classList.remove(classActive);
            (this.reviewsResultWrap as HTMLDivElement).innerHTML = '';
        }, time);
    }

    getFormData() {
        const formData = new FormData(this.form as HTMLFormElement);

        return {
            AuthorName: this.client?.client.name as string,
            AuthorEmail: this.client?.client.email as string,
            ReviewText: formData.get('comment') as string,
            Pros: '',
            Cons: '',
            ProductName: this.product.title,
            ProductURL: this.product.url,
            Rate: Number(formData.get('rating')),
            Date: new Date().toISOString().split('.')[0],
            Recommends: true
        };
    }

    renderResultError() {
        return this.renderResult({
            title: DEFAULT_TEXT.ERROR_TITLE,
            message: DEFAULT_TEXT.ERROR_MESSAGE,
            isError: true
        }, 3000);
    }

    renderResultSuccess() {
        return this.renderResult({
            title: DEFAULT_TEXT.SUCCESS_TITLE,
            message: DEFAULT_TEXT.SUCCESS_MESSAGE,
            isError: false
        }, 5000);
    }

    /**
     * Отправляем отзыв - получаем id - публикуем изображения
     */
    async sendForm() {
        const reviewResponse = await this.api.createProductReview(this.getFormData(), this.product.id)
            .catch(() => {
                return this.renderResultError();
            });

        if (reviewResponse && reviewResponse.Message !== 'Review is added to database and awaiting moderation' || ! reviewResponse.ReviewID) {
            return this.renderResultError();
        }

        if (! this.inputImages.imagesList.filter(Boolean).length) {
            // Картинок нет. Завершаем отправку успешно;
            return this.renderResultSuccess();
        }

        const resultSetImages = await this.api.addImageForReview(reviewResponse.ReviewID, this.inputImages.formData);

        if (resultSetImages.Message === 'Files are uploaded successfully. ') {
            return this.renderResultSuccess();
        }

        return this.renderResultError();
    }
}
